import React, { useCallback, useEffect, useRef, useState } from 'react';
import './NewClaim.scss';
import GlobalParams from '../../helpers/GlobalParams.js';
import Form, { Item, GroupItem, Label, ButtonItem, ButtonOptions, RequiredRule } from 'devextreme-react/form';
import { DataGrid, Column } from 'devextreme-react/data-grid';
import { Button, Lookup, TextBox, LoadPanel, DateBox, NumberBox, CheckBox, FileUploader, Popup } from 'devextreme-react';
import ApiHelper from '../../helpers/ApiHelper.js';
import LabelTemplate from '../../labels/LabelTemplate.js';
import ApiPostHelper from '../../helpers/ApiPostHelper.js';
import notify from 'devextreme/ui/notify';
import DependantForm from '../DependantForm/DependantForm.js';
import BeneficiaryForm from '../BeneficiaryForm/BeneficiaryForm.js';
import axios from 'axios';

function checkMandatoryFiles(filesData, documentsData) {
  // Initialize an array to store missing mandatory files
  const missingFiles = [];

  // Iterate through documentsData to check if mandatory files are uploaded
  documentsData.forEach(document => {
    if (document.IsMandatory) {
      const doc_code = document.code;
      // Check if a file with this code exists in filesData
      const fileUploaded = filesData.find(file => file.hasOwnProperty(doc_code));
      if (!fileUploaded) {
        missingFiles.push(document.description);
      }
    }
  });

  // If any missing mandatory files are found, display notifications
  if (missingFiles.length > 0) {
    const missingFilesMessage = missingFiles.join(', ');
    notify({
      message: `The following mandatory files are not uploaded: ${missingFilesMessage}`,
      position: {
        my: 'center top',
        at: 'center top'
      }
    }, 'error', 5000);
  }
}

var filesData = [];

const validationRules = {
  Names: [{ type: 'required', message: 'Name is required.' }],
  member_no: [{ type: 'required', message: 'Staff No is required.' }],
  dob: [{ type: 'required', message: 'Date of Birth is required.' }],
  MemberAge: [{ type: 'required', message: 'Member Age is required.' }],
  Salary: [{ type: 'required', message: 'Salary is required.' }],
  IDNumber: [{ type: 'required', message: 'ID Number is required.' }],
  DateFrom: [{ type: 'required', message: 'Joining Date is required.' }],
};

const dataGridOptions = {
  allowUpdating: false,
  mode: 'form',
  allowAdding: false,
  allowDeleting: false,
};

const dpGridOptions = {
  allowUpdating: false,
  mode: 'form',
  allowAdding: false,
  allowDeleting: false,
};

///////////grid options///////

var searchPanelOptions = {
  visible: false,
  width: 250
};
console.log(GlobalParams.schemeStore);
var relationshipStoreOptions = {
  dataSource: GlobalParams.RelationshipStore, valueExpr: 'id', displayExpr: 'name'
};
var groupOptions = {
  contextMenuEnabled: true, groupPanel: { visible: true },
};
var scrollingOptions = { mode: 'standard' };
var pagingOptions = { enabled: false };
/////////end of grid options///
const IDNumberEditorOptions = { readOnly: true, maskRules: { X: /[02-9]/ } };

// eslint-disable-next-line import/no-anonymous-default-export
function NewClaim({ onClosePopup, MemberName, MemberNumber, MemberId, PolicyNo, claimId, IsApproval }) {

  const [schemeStore, setSchemeStore] = useState(GlobalParams.schemeStore.filter(scheme => (scheme.StatusCode === "001")));
  const [loanTypesStore, setLoanTypeStore] = useState([]);
  //dependantsData
  const [claimTpyesStore, setClaimTpyesStore] = useState([]);
  const [vsDependantsGrid, setVsDependantsGrid] = useState(false);
  const [dependantsData, setDependantsData] = useState([]);
  const [attachmentData, setAttachmentData] = useState([]);
  //beneficiaries Data
  const [vsBeneficiariesGrid, setVsBeneficiariesGrid] = useState(false);
  const [beneficiariesData, setBeneficiariesData] = useState([]);
  //filesUpload
  const [fileUploadData, setFileUploadData] = useState({});
  const [selectedFiles, setSelectedFiles] = useState([]);

  const [dpRelation, setDpRelation] = useState(null);
  const [vsDeath, setVsDeath] = useState(false);
  const [vsDpDeath, setVsDpDeath] = useState(false);
  const [vsBank, setVsBank] = useState(false);
  const [vsMpesa, setVsMpesa] = useState(false);
  const [bankBranches, setBankBranches] = useState([]);
  const [vsPayMethod, setVsPayMethod] = useState(false);

  const [member_id, setMemberId] = useState(null);
  /*useEffect(() => {
    console.log('memberid set: ' + MemberId);
    setMemberId(MemberId)
  }, []);*/

  //useEffect
  const [isLoading, setIsLoading] = useState(false);
  //////search form//////
  {/*paymentOptions,PayMethod, Bank, BankBranch, BankAccount, MobileNumber*/ }
  var default_form =
  {
    portal_user_id: GlobalParams.ContactPersonId,
    Names: MemberName,
    member_no: MemberNumber,
    member_id: MemberId,
    scheme_benefit_id: null,
    scheme_id: PolicyNo,
    event_date: null,
    ClaimReason: null,
    claim_cause_id: null,
    paymentOptions: null,

    //PayMethod: null,
    //Bank: null,
    //BankBranch: null,
    //BankAccount: '',
    //BankAccountName: '',
    //MoMoTelco: '',
    //MoMoNumber: '',

    ClaimDefaultPay_method: null,
    ClaimDefaultEFTBank_code: null,
    ClaimDefaultEFTBankBranchCode: null,
    ClaimDefaultEFTBank_account: '',
    ClaimDefaultEftBankaccountName: '',
    ClaimDefaultTelcoCompany: '',
    ClaimDefaultMobileWallet: '',

    DeathCertNo: '',
    DeathEntryNo: '',
    BurialPermitNumber: '',

    LastWorkingDate: null,
    PlaceOfDeath: '',
    CauseOfDeath: '',
    Rank: '',
    Station: '',
    Age: 0,
    YearOfEmployment: '',
    Gender: null,

    LoanType: null,
    ContributionYears: 0,
    AnyOutstandingLoan: null,
    AnyOtherInstitutionLoan: null,
    LoanAmount: 0,
    LoanAmountInWords: '',
    //Remember to Add LoanType here.....
    LoanPurpose: '',
    RepaymentPeriod: 0,
    CurrentNetPay: 0,
    YearsToRetirement: 0,

    Alcohol: '',
    NamePhoneOfWitness: '',
    ExactInjury: '',
    YouHospitalized: null,
    Hospital: '',
    DoctorName: '',
    AreYouDisabled: null,
    DisabilityDateFrom: null,
    DisabilityDateTo: null,
    DisPrevWork: '',
    HasAffectedSex: null,
    SexCondition: '',
    ConsultSexDoctor: null,
    SexDoctorName: '',
    SexDoctorMobile: '',

    DreadIllness: '',
    DateIllnessCommencement: null,
    DreadCondition: '',
    BodyPartImpaired: '',
    AffectedDuties: '',
    AbleToWork: '',
    RelationshipType: null,
    DpWitnessName: '',
    DpWitnessMobile: '',


    OICRecomendation: null,
    OICComments: '',
    SecretariatRecomendation: null,
    SecretariatComments: '',
    BrokerRecomendation: null,
    BrokerComments: ''
  };
  const claimStore = useRef(default_form);


  //const [claimStore, setClaimStore] = useState(default_form);

  useEffect(() => {
    //async function fetchClaimTypes(){
    if (claimTpyesStore === undefined || claimTpyesStore.length === 0) {
      //setClaimStore({ ...claimStore, scheme_id: PolicyNo });
      claimStore.current = { ...claimStore.current, scheme_id: PolicyNo };

      //fetch the right benefits
      setIsLoading(true);
      //let tmp_claimTypeStore = await fetchClaimTypes(PolicyNo);

      //check if its popfund - setVsPOPFund
      var SchemeDetails = GlobalParams.schemeStore.find(item => item.schemeID === PolicyNo);
      console.log(SchemeDetails);
      if (SchemeDetails.IsPopFund === "1" || SchemeDetails.IsPopFund === true) {
        setIsPOPFund(true);
        fetchClaimTypes(true, PolicyNo);
      } else {
        fetchClaimTypes(false, PolicyNo);
      }


    }

    ///if claimId = 0 then fetch data from the db and display it...
    if (claimId > 0) {
      setIsLoading(true);
      fetchClaimDetails();
    }


    //}
    //fetchClaimTypes();
  }, [claimTpyesStore]);

  const fetchClaimDetails = async (scheme_id) => {
    try {
      setIsLoading(true);
      const result = await ApiHelper.fetchData(
        GlobalParams.ApiUrlPrefix + 'get-claim-requests?id=' + claimId,
        GlobalParams.bearerToken
      );
      //SchemeBenefit
      setIsLoading(false);
      //setClaimStore({ ...claimStore, scheme_benefit_id: result.data[''] });
      if (result.data[0]['ClaimDefaultPay_method'] === "4" || result.data[0]['ClaimDefaultPay_method'] === "7") {
        var tmp_bankBranch = await fetchBankBranch(result.data[0]['ClaimDefaultEFTBank_code']);
        setBankBranches(tmp_bankBranch);
      }
      PaymentMethodChanged(result.data[0]['ClaimDefaultPay_method']);
      claimStore.current = { ...claimStore.current, ...result.data[0] };

      if (result.docs.length > 0) {
        setVsGroupAttachmentsData(true);
        setAttachmentData(result.docs);
      }


    } catch (error) {
      // Handle error, e.g., show an error message
      console.log(error);
      setIsLoading(false);
    }
  };

  const validateForm = (e) => {
    // Implement your validation logic here
    console.log('Form content is ready:', e);
  };

  const onNameValueChanged = (e) => {
    if (e.value !== undefined && e.value !== null && e.value !== '') {
      claimStore.current({ ...claimStore.current, Names: e.value });
    }
  };

  const onMemberNoValueChanged = (e) => {
    if (e.value !== undefined && e.value !== null && e.value !== '') {
      claimStore.current({ ...claimStore.current, member_no: e.value });
    }
  };

  const onSchemeChanged = (e) => {
    if (e.value !== undefined && e.value !== null && e.value !== '') {
      claimStore.current({ ...claimStore.current, scheme_id: e.value });
    }
  };

  const clear_form = () => {
    claimStore.current = { ...claimStore.current, ...default_form };
  }

  const postAutomate = async (request_id) => {
    try {

      let post_data = {
        'claim_request_id': request_id
      };
      console.log(post_data);
      const result = await axios.post(
        GlobalParams.ApiUrlPrefix + "get-claims-processing-results",
        post_data,
        {
          headers: {
            'Authorization': 'Bearer ' + GlobalParams.bearerToken, // Include bearer token in the Authorization header
            'Content-Type': 'multipart/form-data'
          }
        }
      );
      //console.log(result.data.request_id);
      console.log("Automation Request finished");
    } catch (error) {
      setIsLoading(false);
      console.log(error);
      notify(error.response.data.message, 'error', 5000);
    }
  };

  const postClaim = async (post_data) => {
    try {
      let tmp_dependantsData = dependantsData || [];
      let tmp_beneficiariesData = beneficiariesData || [];
      let tmp_filesData = filesData || [];
      post_data.portal_user_id = GlobalParams.ContactPersonId;

      let combinedHashmap = tmp_dependantsData.length > 0 ? tmp_dependantsData.reduce((acc, obj, index) => {
        // Assuming the formdata is the key 'key' in each object
        Object.keys(obj).forEach(key => {
          acc[`dependant[${index}][${key}]`] = obj[key];
        });
        return acc;
      }, { ...post_data }) : post_data;

      combinedHashmap = tmp_beneficiariesData.length > 0 ? tmp_beneficiariesData.reduce((acc, obj, index) => {
        // Assuming the formdata is the key 'key' in each object
        Object.keys(obj).forEach(key => {
          acc[`beneficiary[${index}][${key}]`] = obj[key];
        });
        return acc;
      }, { ...post_data }) : post_data;

      combinedHashmap = tmp_filesData.length > 0 ? tmp_filesData.reduce((acc, obj, index) => {
        // Assuming the formdata is the key 'key' in each object
        Object.keys(obj).forEach(key => {
          acc[`files[${key}]`] = obj[key];
        });
        return acc;
      }, { ...post_data }) : post_data;

      //combinedHashmap = { ...combinedHashmap, ...filesData }

      console.log(combinedHashmap);
      /*const result = await ApiPostHelper.postData(
        GlobalParams.ApiUrlPrefix + "submit-claim-request",
        GlobalParams.bearerToken,
        JSON.stringify(combinedHashmap)
      );*/
      const result = await axios.post(
        GlobalParams.ApiUrlPrefix + "submit-claim-request",
        combinedHashmap,
        {
          headers: {
            'Authorization': 'Bearer ' + GlobalParams.bearerToken, // Include bearer token in the Authorization header
            'Content-Type': 'multipart/form-data'
          }
        }
      );
      console.log(result.data.data.claim_request_id);
      if (result.status === 200) {
        setIsLoading(false);
        clear_form();
        notify(result.data.message, 'success', 5000);
        //postAutomate(result.data.data.claim_request_id);
        onClosePopup();
      }
    } catch (error) {
      setIsLoading(false);
      console.log(error);
      notify(error.response.data.message, 'error', 5000);
    }
  };

  const postApproval = async (post_data) => {
    try {
      let ClaimStatus = '014';
      if (GlobalParams.IsClientLoggedIn) {
        if (GlobalParams.PopFundAccessLevelId === 1 ||
          GlobalParams.PopFundAccessLevelId === "1") {
          if (post_data.OICRecomendation === "APPROVED") {
            ClaimStatus = '015';
          } else {
            ClaimStatus = '005';
          }
        }
        if (GlobalParams.PopFundAccessLevelId === 2 ||
          GlobalParams.PopFundAccessLevelId === "2") {
          if (post_data.OICRecomendation === "APPROVED") {
            ClaimStatus = '013';
          } else {
            ClaimStatus = '005';
          }
        }
      } else {
        //its a broker...
        if (post_data.BrokerRecomendation === "APPROVED") {
          ClaimStatus = '013';
        } else {
          ClaimStatus = '005';
        }
      }


      let combinedHashmap = {
        'id': claimId,
        'ClaimStatus': ClaimStatus,
        'OICRecomendation': post_data.OICRecomendation,
        'OICComments': post_data.OICComments,
        'SecretariatRecomendation': post_data.SecretariatRecomendation,
        'SecretariatComments': post_data.SecretariatComments,
        'BrokerRecomendation': post_data.BrokerRecomendation,
        'BrokerComments': post_data.BrokerComments
      };

      const result = await axios.post(
        GlobalParams.ApiUrlPrefix + "approve-claim",
        combinedHashmap,
        {
          headers: {
            'Authorization': 'Bearer ' + GlobalParams.bearerToken, // Include bearer token in the Authorization header
            'Content-Type': 'multipart/form-data'
          }
        }
      );
      if (result.status === 200) {
        setIsLoading(false);
        clear_form();
        notify(result.data.message, 'success', 5000);
        onClosePopup();
      }
    } catch (error) {
      setIsLoading(false);
      console.log(error);
      notify(error.response.data.message, 'error', 5000);
    }
  };

  const fetchBankBranch = async (bank_code) => {
    try {
      const result = await ApiHelper.fetchData(
        GlobalParams.ApiUrlPrefix + 'get-bank-branches-codes?bankCode=' + bank_code,
        GlobalParams.bearerToken
      );
      return result.data;
    } catch (error) {
      // Handle error, e.g., show an error message
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  /////end of search form///
  const emptyItemConfig = {
    colSpan: 3,
    itemType: 'empty',
  };


  const fetchDocs = async (claim_type_id) => {
    try {
      const result = await ApiHelper.fetchData(
        GlobalParams.ApiUrlPrefix + "get-required-docs?claim_type_id=" + claim_type_id,
        GlobalParams.bearerToken
      );
      setIsLoading(false);
      console.log(result.data);
      setDocumentsData(result.data);
    } catch (error) {
      // Handle error, e.g., show an error message
      console.log(error);
      setIsLoading(false);
    }
  };

  const fetchDp = async (member_id) => {
    try {
      const result = await ApiHelper.fetchData(
        GlobalParams.ApiUrlPrefix + "get-dependants-on-member?member_id=" + member_id,
        GlobalParams.bearerToken
      );
      return result.data;
    } catch (error) {
      // Handle error, e.g., show an error message
      console.log(error);
      setIsLoading(false);
      //notify(error.response.data.message,5000);
    }
  };

  const fetchClaimTypes = async (is_pop_fund, schemeId) => {
    try {
      const result = await ApiHelper.fetchData(
        GlobalParams.ApiUrlPrefix + "get-scheme-benefit?scheme_id=" + schemeId,
        GlobalParams.bearerToken
      );

      setIsLoading(false);
      //filter the loanTypes LoanTypes
      var tmploanTypesStore = GlobalParams.LoanTypes;
      setLoanTypeStore(tmploanTypesStore.filter(scheme => (scheme.Scheme === "413" || scheme.Scheme === 413)));
      let tmp_claimTypeStore = result.data;
      setClaimTpyesStore(result.data);
      let isLoggedIn = (localStorage.getItem('isLoggedIn') === '1');
      console.log(is_pop_fund);
      if (is_pop_fund && tmp_claimTypeStore.length > 0) {
        if (!isLoggedIn) {
          //don't display DTH....
          console.log("Not logged in");
          setClaimTpyesStore(tmp_claimTypeStore.filter(scheme =>
            (scheme.ClaimType !== "DTHGRP" && scheme.ClaimType !== "WTH")
          ));
        } else {
          if (GlobalParams.PopFundAccessLevelId === "1" || GlobalParams.PopFundAccessLevelId === "2") {
            //display the DTH benefits...
            setClaimTpyesStore(tmp_claimTypeStore);
          } else {
            //don't display DTH...
            setClaimTpyesStore(tmp_claimTypeStore.filter(scheme => (scheme.ClaimType !== "DTHGRP")));
          }
        }
      } else {
        setClaimTpyesStore(tmp_claimTypeStore);
      }
    } catch (error) {
      // Handle error, e.g., show an error message
      console.log(error);
      setIsLoading(false);
      setClaimTpyesStore([]);
      //notify(error.response.data.message,5000);
    }
  }

  const fetchBenef = async (member_id) => {
    try {
      const result = await ApiHelper.fetchData(
        GlobalParams.ApiUrlPrefix + "get-member-benef?member_id=" + member_id,
        GlobalParams.bearerToken
      );
      return result.data;
    } catch (error) {
      // Handle error, e.g., show an error message
      console.log(error);
      setIsLoading(false);
      //notify(error.response.data.message,5000);
    } finally {
      // Set isLoading to false after renderPdfViewer completes
      setIsLoading(false);
    }
  };



  const [vsDocumentsGrid, setvsDocumentsGrid] = useState(true);
  const [documentsData, setDocumentsData] = useState([]);


  const doSave = useCallback(async (e) => {

    e.preventDefault();

    if (IsApproval === 1) {
      //just submit the Approval
      setIsLoading(true);
      postApproval(claimStore.current);
    } else {
      console.log('dependants:', dependantsData);
      if (vsDependantsGrid && (dependantsData === undefined || dependantsData === null || dependantsData.length === 0)) {
        notify('Kindly add Dependants', 'error', 5000);
        return;
      }
      if (vsBeneficiariesGrid && (beneficiariesData === undefined || beneficiariesData === null || beneficiariesData.length === 0)) {
        notify('Kindly add Beneficiaries', 'error', 5000);
        return;
      }

      if (documentsData !== undefined && documentsData !== null && documentsData.length !== 0) {
        // Initialize an array to store missing mandatory files
        const missingFiles = [];

        // Iterate through documentsData to check if mandatory files are uploaded
        documentsData.forEach(document => {
          if (document.IsMandatory) {
            const doc_code = document.req_code;
            // Check if a file with this code exists in filesData
            const fileUploaded = filesData.find(file => file.hasOwnProperty(doc_code));
            if (!fileUploaded) {
              missingFiles.push(document.description);
            }
          }
        });

        // If any missing mandatory files are found, display notifications
        if (missingFiles.length > 0) {
          const missingFilesMessage = missingFiles.join(', ');
          notify({
            message: `The following mandatory files are not uploaded: ${missingFilesMessage}`,
            position: {
              my: 'center top',
              at: 'center top'
            }
          }, 'error', 5000);
          return;
        }

      }

      // Now you can submit the combined data to your backend or perform any other actions
      // Combine other form data with fileUploadData
      //let claim_store = { ...claimStore, ...fileUploadData };
      console.log('files data:', selectedFiles);
      console.log('files data:', filesData);
      console.log('submited data:', claimStore.current);
      setIsLoading(true);
      postClaim(claimStore.current);
    }


  }, [dependantsData, beneficiariesData, claimStore, selectedFiles]);

  ///////////dependant popup////
  const [vsPopupDependant, setVsPopupDependant] = useState(false);

  //////////end of dependant popup//
  const [popupDpVisible, setPopupDpVisible] = useState(false);
  const [popupBenVisible, setPopupBenVisible] = useState(false);
  const hideDpPopup = () => {
    setPopupDpVisible(false);
  };
  const hideBenPopup = () => {
    setPopupBenVisible(false);
  };

  {/* TODO - Initialize all Groups */ }
  const [vsGroupDeath, setVsGroupDeath] = useState(false);
  const [vsGroupAccident, setVsGroupAccident] = useState(false);
  const [vsGroupAccidentSex, setVsGroupAccidentSex] = useState(false);
  const [vsGroupOtherDetails, setVsGroupOtherDetails] = useState(false);
  const [vsGroupDreadDisease, setVsGroupDreadDisease] = useState(false);
  const [vsGroupAttachmentsData, setVsGroupAttachmentsData] = useState(false);


  const [IsPOPFund, setIsPOPFund] = useState(false);
  const [vsClaimPayMethod, setVsClaimPayMethod] = useState(false);
  const [vsClaimReason, setVsClaimReason] = useState(false);
  const [vsClaimClauseId, setVsClaimClauseId] = useState(false);
  const [vsClaimPaymentOptions, setVsClaimPaymentOptions] = useState(false);


  {/*vsRelationshipType,vsDpWitnessName,RelationshipType,DpWitnessName,DpWitnessMobile  */ }
  const [vsLastWorkingDate, setVsLastWorkingDate] = useState(false);//
  const [vsPlaceOfDeath, setVsPlaceOfDeath] = useState(false);
  const [vsCauseOfDeath, setVsCauseOfDeath] = useState(false);
  const [vsRelationshipType, setVsRelationshipType] = useState(false);
  const [vsDpWitnessName, setVsDpWitnessName] = useState(false);
  const [vsDpWitnessMobile, setVsDpWitnessMobile] = useState(false);

  const [vsRank, setVsRank] = useState(false);
  const [vsStation, setVsStation] = useState(false);
  const [vsAge, setVsAge] = useState(false);
  const [vsYearOfEmployment, setVsYearOfEmployment] = useState(false);
  const [vsGender, setVsGender] = useState(false);

  const [vsContributionYears, setVsContributionYears] = useState(false);
  const [vsAnyOutstandingLoan, setVsAnyOutstandingLoan] = useState(false);
  const [vsAnyOtherInstitutionLoan, setVsAnyOtherInstitutionLoan] = useState(false);
  const [vsLoanAmount, setVsLoanAmount] = useState(false);
  const [vsLoanType, setVsLoanType] = useState(false);
  const [vsLoanAmountInWords, setVsLoanAmountInWords] = useState(false);
  const [vsLoanPurpose, setVsLoanPurpose] = useState(false);
  const [vsRepaymentPeriod, setVsRepaymentPeriod] = useState(false);
  const [vsCurrentNetPay, setVsCurrentNetPay] = useState(false);
  const [vsYearsToRetirement, setVsYearsToRetirement] = useState(false);

  const [vsGroupPaymentDetails, setVsGroupPaymentDetails] = useState(false);
  const [vsGroupApproval, setVsGroupApproval] = useState(false);

  const [vsOICRecomendation, setVsOICRecomendation] = useState(false);
  const [vsOICComments, setVsOICComments] = useState(false);
  const [vsSecretariatRecomendation, setVsSecretariatRecomendation] = useState(false);
  const [vsSecretariatComments, setVsSecretariatComments] = useState(false);
  const [vsBrokerRecomendation, setVsBrokerRecomendation] = useState(false);
  const [vsBrokerComments, setVsBrokerComments] = useState(false);

  const [vsHospital, setVsHospital] = useState(false);
  const [vsDoctorName, setVsDoctorName] = useState(false);
  const [vsDisabilityDateFrom, setVsDisabilityDateFrom] = useState(false);
  const [vsDisabilityDateTo, setVsDisabilityDateTo] = useState(false);
  const [vsSexDoctorName, setVsSexDoctorName] = useState(false);
  const [vsSexDoctorMobile, setVsSexDoctorMobile] = useState(false);

  const DefaultForm = () => {
    //default grouping
    setVsGroupDeath(false);
    setVsGroupAccident(false);
    setVsGroupAccidentSex(false);
    setVsGroupOtherDetails(false);
    setVsGroupPaymentDetails(true);
    setVsGroupApproval(false);
    setVsGroupDreadDisease(false);

    setVsOICRecomendation(false);
    setVsOICComments(false);
    setVsSecretariatRecomendation(false);
    setVsSecretariatComments(false);
    setVsBrokerRecomendation(false);
    setVsBrokerComments(false);

    ///the default form
    setVsClaimPayMethod(true);
    setVsClaimReason(false);
    setVsClaimClauseId(false);
    setVsClaimPaymentOptions(true);

    setVsRank(false);
    setVsStation(false);
    setVsAge(false);
    setVsYearOfEmployment(false);
    setVsGender(false);

    setVsLastWorkingDate(false);
    setVsPlaceOfDeath(false);
    setVsCauseOfDeath(false);
    setVsRelationshipType(false);
    setVsDpWitnessName(false);
    setVsDpWitnessMobile(false);


    setVsContributionYears(false);
    setVsAnyOutstandingLoan(false);
    setVsAnyOtherInstitutionLoan(false);
    setVsLoanType(false);
    setVsLoanAmount(false);
    setVsLoanAmountInWords(false);
    setVsLoanPurpose(false);
    setVsRepaymentPeriod(false);
    setVsCurrentNetPay(false);
    setVsYearsToRetirement(false);


  }

  const PaymentMethodChanged = (paymentMethod) => {
    //TODO - Get the Bank Branches...
    setVsBank(false);
    setVsMpesa(false);
    if (paymentMethod === '7') {
      console.log(paymentMethod);
      setVsBank(true);
    } else if (paymentMethod === '6') {
      setVsMpesa(true);
    }
  }

  const ClaimTypeChanged = (claimType) => {
    DefaultForm();
    if (IsApproval === 1) {
      setVsGroupAttachmentsData(true);
    }
    //based on the claim Type display the necessary form....
    //if its popfund refund
    if (claimType === "DTHGRP") {
      setVsGroupPaymentDetails(true);
    }
    // if its death....
    if (claimType === "DTHGRP" || claimType === "DTHCR" || claimType === "051" || 
      claimType === "037" || claimType === "DDF" || claimType === "0066") {
      setVsGroupDeath(true);
      if (IsPOPFund) {
        setVsRank(true);
        setVsStation(true);
        setVsAge(true);
        setVsYearOfEmployment(true);
        setVsGender(true);

        setVsLastWorkingDate(true);
        setVsPlaceOfDeath(true);
        setVsCauseOfDeath(true);
      }
    }
    if (claimType === "046" || claimType === "047") {
      setVsGroupDeath(true);
      if (IsPOPFund) {
        setVsRank(true);
        setVsStation(true);
        setVsAge(true);
        setVsYearOfEmployment(true);
        setVsGender(true);

        setVsRelationshipType(true);
        setVsDpWitnessName(true);
        setVsDpWitnessMobile(true);
        setVsPlaceOfDeath(true);
        setVsCauseOfDeath(true);
      }
    }
    if (claimType === "LON") {
      setVsLoanType(true);
      setVsGroupOtherDetails(true);
      if (IsPOPFund) {
        setVsGroupPaymentDetails(true);
        setVsClaimPayMethod(true);
        setVsRank(true);
        setVsStation(true);
        setVsAge(true);
        setVsYearOfEmployment(true);
        setVsGender(true);

        setVsContributionYears(true);
        setVsAnyOutstandingLoan(true);
        setVsAnyOtherInstitutionLoan(true);
        setVsLoanAmount(true);
        setVsLoanAmountInWords(true);
        setVsLoanPurpose(true);
        setVsRepaymentPeriod(true);
        setVsCurrentNetPay(true);
        setVsYearsToRetirement(true);
      }
    }
    if (claimType === "041") { //dread disease / terminal illness
      setVsGroupDreadDisease(true);
      if (IsPOPFund) {
        setVsRank(true);
        setVsStation(true);
        setVsAge(true);
        setVsYearOfEmployment(true);
        setVsGender(true);
      }
    }
    if (claimType === "TTD") { //Accident / permanent disability
      setVsGroupAccident(true);
      setVsGroupAccidentSex(true);
      if (IsPOPFund) {
        setVsRank(true);
        setVsStation(true);
        setVsAge(true);
        setVsYearOfEmployment(true);
        setVsGender(true);
      }
    }

    if (IsApproval === 1) {
      setVsGroupApproval(true);
      if (GlobalParams.IsClientLoggedIn) {
        if (GlobalParams.PopFundAccessLevelId === 1 || GlobalParams.PopFundAccessLevelId === "1") {
          //OIC
          setVsOICRecomendation(true);
          setVsOICComments(true);
        }
        else if (GlobalParams.PopFundAccessLevelId === 2 || GlobalParams.PopFundAccessLevelId === "2") {
          //view OIC recommendation and comments...
          setVsOICRecomendation(true);
          setVsOICComments(true);
          //Secretariat
          setVsSecretariatRecomendation(true);
          setVsSecretariatComments(true);
        }
      } else {
        setVsBrokerRecomendation(true);
        setVsBrokerComments(true);
      }
    }
  }



  return (
    <div className="App">
      <div>
        <Popup
          hideOnOutsideClick={false}
          visible={popupDpVisible}
          onHiding={hideDpPopup}
          title="ADD NEW DEPENDANT"
          position={{ my: 'top', at: 'top', of: window }}
          height={300}
        >
          <DependantForm onClosePopup={(e) => {
            setDependantsData((prevData) => {
              // Ensure prevData is initialized as an array
              const tmp_dependant = Array.isArray(prevData) ? [...prevData, e] : [e];
              console.log(tmp_dependant);
              return tmp_dependant;
            });
            hideDpPopup();
          }} vsDeath={vsDpDeath} relation={dpRelation} />
        </Popup>
      </div>
      <div>
        <Popup
          hideOnOutsideClick={false}
          visible={popupBenVisible}
          onHiding={hideBenPopup}
          position={{ my: 'top', at: 'top', of: window }}
          title="ADD NEW BENEFICIARY"
        >
          <BeneficiaryForm onClosePopup={(e) => {
            // let tmp_beneficiaries = beneficiariesData || [];
            // tmp_beneficiaries.push(e);
            // console.log(tmp_beneficiaries);
            setBeneficiariesData((prevData) => {
              // Ensure prevData is initialized as an array
              const tmp_beneficiaries = Array.isArray(prevData) ? [...prevData, e] : [e];
              console.log(tmp_beneficiaries);
              return tmp_beneficiaries;
            });
            hideBenPopup();
          }} />
        </Popup>
      </div>
      {isLoading && <LoadPanel visible={true} />}
      <br />
      <form onSubmit={doSave}>
        <Form
          formData={claimStore.current}>
          {/*TODO-Group the entire form*/}
          <GroupItem colCount={3} caption="Claimant Details">
            <Item
              colSpan={2}
              dataField="Names"
              editorType="dxTextBox"
              validationRules={validationRules.Names}
              editorOptions={
                {
                  readOnly: false,
                  onValueChanged: { onNameValueChanged },
                  value: MemberName
                }
              }
            >
              <Label text='Name' location="top" />
            </Item>

            <Item
              dataField="member_no"
              editorType="dxTextBox"
              editorOptions={
                {
                  readOnly: true,
                  onValueChanged: { onMemberNoValueChanged },
                  value: MemberNumber
                }
              }
            >
              <Label text='Staff Number' location="top" />
            </Item>

            <Item
              colSpan={3}
              dataField="scheme_id"
              editorType="dxLookup"
              editorOptions={
                {
                  readOnly: true,
                  dataSource: GlobalParams.schemeStore,
                  //displayExpr: "PortalDescription",
                  displayExpr: "PolicyCompany",
                  valueExpr: "schemeID",
                  searchEnabled: false,
                  onValueChanged: async (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      //fetch the right benefits
                      setIsLoading(true);
                      await fetchClaimTypes(IsPOPFund, e.value);
                      setIsLoading(false);
                    }
                  },
                  value: PolicyNo
                }
              }
            >
              <RequiredRule message="Policy No / Scheme is required" />
              <Label text='Policy No / Scheme' location="top" />
            </Item>

            <Item
              colSpan={3}
              dataField="scheme_benefit_id"
              editorType="dxLookup"
              editorOptions={
                {
                  dataSource: claimTpyesStore,
                  displayExpr: "Description",
                  valueExpr: "id",
                  searchEnabled: false,
                  onValueChanged: async (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      console.log(claimTpyesStore);
                      //fetch the claimType from the benefits...
                      var SchemeBenefits = await claimTpyesStore.find(item => item.id === e.value);
                      let tmpClaimType = SchemeBenefits.ClaimType;

                      ClaimTypeChanged(tmpClaimType);
                      if (IsApproval === 0) {
                        fetchDocs(tmpClaimType);
                      }
                    }
                  },
                }
              }
            >
              <RequiredRule message="Claim Type is required" />
              <Label text='Claim Type' location="top" />
            </Item>

            {/* Loan Type */}
            <Item
              dataField="LoanType"
              visible={vsLoanType}
              editorType="dxLookup"
              editorOptions={
                {
                  dataSource: loanTypesStore,
                  displayExpr: "LoanTypeDesc",
                  valueExpr: "ID",
                  searchEnabled: false,
                  onValueChanged: (e) => {
                    //if (e.value !== undefined && e.value !== null && e.value !== '') {
                      //setClaimStore({ ...claimStore, ClaimReason: e.value });
                    //}
                  },
                }
              }
            >
              <RequiredRule message="Loan Type is required" />
              <Label text='Type of Loan' location="top" />
            </Item>

            <Item visible={vsClaimReason} {...emptyItemConfig} />

            <Item
              dataField="ClaimReason"
              visible={vsClaimReason}
              editorType="dxLookup"
              editorOptions={
                {
                  dataSource: GlobalParams.ClaimReasons,
                  displayExpr: "Description",
                  valueExpr: "id",
                  searchEnabled: false,
                  onValueChanged: (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      //setClaimStore({ ...claimStore, ClaimReason: e.value });
                    }
                  },
                }
              }
            >
              <RequiredRule message="Claim Reason is required" />
              <Label text='Claim Reason' location="top" />
            </Item>


            <Item
              dataField="claim_cause_id"
              visible={vsClaimClauseId}
              editorType="dxLookup"
              editorOptions={
                {
                  dataSource: GlobalParams.ClaimCauses,
                  displayExpr: "Description",
                  valueExpr: "claim_cause_code",
                  searchEnabled: false,
                  onValueChanged: (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      //setClaimStore({ ...claimStore, claim_cause_id: e.value });
                    }
                  },
                }
              }
            >
              <RequiredRule message="Claim Cause is required" />
              <Label text='Claim Cause' location="top" />
            </Item>







            <Item visible={vsDependantsGrid} {...emptyItemConfig} />



            {/* display the dependants if death of dependant & */}
            <ButtonItem
              visible={vsDependantsGrid}
              colSpan={3}
            >
              <ButtonOptions
                type='danger'
                width={180}
                text="Add Dependant"
                icon='plus'
                onClick={
                  () => {
                    setPopupDpVisible(true);
                  }
                }
              />
            </ButtonItem>
            <Item colSpan={3}>
              <DataGrid
                visible={vsDependantsGrid} width={'96%'}
                dataSource={dependantsData} wordWrapEnabled={true} columnHidingEnabled={false}
                searchPanel={searchPanelOptions} editing={dpGridOptions}
                allowColumnReordering={true} scrolling={scrollingOptions} paging={pagingOptions}>
                {/*ID, MemberId, Name, DependantNo, SumAssured, Premium, Relation, Status, IsActive */}
                <Column dataField="Name" ></Column>
                <Column dataField="Relation"
                  lookup={
                    { dataSource: GlobalParams.RelationshipStore, valueExpr: 'id', displayExpr: 'name' }}></Column>
                <Column dataField="dob"></Column>
                <Column dataField="IDNumber"></Column>
              </DataGrid>
            </Item>


            <Item visible={vsBeneficiariesGrid} {...emptyItemConfig} />

            {/*beneficiaries */}
            {/*GuardianSurname, GuardianOtherNames, GuardianTelephone, GuardianEmail, email, 
            PostalAddress, PostalCode, Surname, OtherNames, Names, relationship, perc_alloc, birth_date */}
            <ButtonItem
              visible={vsBeneficiariesGrid}
              colSpan={3}
            >
              <ButtonOptions
                type='danger'
                width={180}
                text="Add Beneficiary"
                icon='plus'
                onClick={
                  () => {
                    setPopupBenVisible(true);
                  }
                }
              />
            </ButtonItem>
            <Item colSpan={3}>
              <DataGrid
                visible={vsBeneficiariesGrid} width={'96%'}
                dataSource={beneficiariesData} wordWrapEnabled={true} columnHidingEnabled={false}
                searchPanel={searchPanelOptions} editing={dataGridOptions}
                allowColumnReordering={true} scrolling={scrollingOptions} paging={pagingOptions}>
                <Column dataField="id" visible={false}></Column>
                <Column dataField="Names" visible={false}></Column>
                <Column dataField="relationship" visible={true}
                  lookup={
                    { dataSource: GlobalParams.RelationshipStore, valueExpr: 'id', displayExpr: 'name' }}
                >
                </Column>
                <Column dataField="perc_alloc" ></Column>
                <Column dataField="birth_date" dataType='date'></Column>
                <Column dataField="GuardianSurname" visible={false}></Column>
                <Column dataField="GuardianOtherNames" visible={false}></Column>
                <Column dataField="GuardianTelephone" visible={false}></Column>
                <Column dataField="GuardianEmail" visible={false}></Column>

                <Column dataField="ClaimDefaultPay_method" visible={false}></Column>
                <Column dataField="ClaimDefaultEFTBank_code" visible={false}></Column>
                <Column dataField="BankBranch" visible={false}></Column>
                <Column dataField="BankAccount" visible={false}></Column>
                <Column dataField="MobileNumber" visible={false}></Column>
                <Column dataField="IsInstitution" visible={false}></Column>
                <Column dataField="KRAPIN" visible={false}></Column>
              </DataGrid>
            </Item>

            {/*Bank, BankBranch, BankAccount, MobileNumber, IsInstitution, KRAPIN, ClaimDefaultPay_method */}

            <Item visible={vsBeneficiariesGrid} {...emptyItemConfig} />


            {/*Add fields for pop fund Deceased Prisons Officer fields */}
            {/*Rank, Station, Age, Year of employement, Gender */}


            <Item
              dataField="Rank"
              visible={vsRank}
              editorType="dxTextBox"
              editorOptions={
                {
                  readOnly: false,
                  onValueChanged: (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      //setClaimStore({ ...claimStore, Rank: e.value });
                    }
                  }
                }
              }
            >
              <RequiredRule message="Rank is required" />
              <Label text='Rank' location="top" />
            </Item>

            <Item
              dataField="Station"
              visible={vsStation}
              editorType="dxTextBox"
              editorOptions={
                {
                  readOnly: false,
                  onValueChanged: (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      //setClaimStore({ ...claimStore, Station: e.value });
                    }
                  }
                }
              }
            >
              <RequiredRule message="Station is required" />
              <Label text='Station' location="top" />
            </Item>

            <Item
              dataField="Age"
              visible={vsAge}
              editorType="dxNumberBox"
              editorOptions={
                {
                  readOnly: false,
                  onValueChanged: (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      //setClaimStore({ ...claimStore, Age: e.value });
                    }
                  }
                }
              }
            >
              <RequiredRule message="Age is required" />
              <Label text='Age' location="top" />
            </Item>

            <Item
              dataField="YearOfEmployment"
              visible={vsYearOfEmployment}
              editorOptions={
                {
                  mask: '0000',
                  maskRules: { X: /[02-9]/ },
                  readOnly: false,
                  onValueChanged: (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      //setClaimStore({ ...claimStore, YearOfEmployment: e.value });
                    }
                  }
                }
              }
            >
              <RequiredRule message="Year of Employment is required" />
              <Label text='Year of Employment' location="top" />
            </Item>

            <Item
              colSpan={2}
              dataField="Gender"
              visible={vsGender}
              editorType="dxLookup"
              editorOptions={
                {
                  dataSource: GlobalParams.GenderStore,
                  displayExpr: "Desc",
                  valueExpr: "Code",
                  searchEnabled: false,
                  onValueChanged: (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      //setClaimStore({ ...claimStore, Gender: e.value });
                    }
                  },
                }
              }
            >
              <RequiredRule message="Gender is required" />
              <Label text='Gender' location="top" />
            </Item>


            <Item {...emptyItemConfig} />
          </GroupItem>

          {/*Death Claim */}
          <GroupItem colCount={3} caption="DEATH DETAILS" visible={vsGroupDeath}>

            {/*Relationship */}
            <Item
              dataField="RelationshipType"
              visible={vsRelationshipType}
              editorType="dxLookup"
              editorOptions={
                {
                  dataSource: GlobalParams.RelationshipStore,
                  displayExpr: "name",
                  valueExpr: "id",
                  searchEnabled: false,
                }
              }
            >
              <RequiredRule message="Relationship is Required" />
              <Label text='Relationship' />
            </Item>


            <Item
              colSpan={3}
              dataField="LastWorkingDate"
              visible={vsLastWorkingDate}
              editorType="dxDateBox"
              editorOptions={
                {
                  readOnly: false,
                  displayFormat: "dd/MM/yyyy",
                  onValueChanged: (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      //setClaimStore({ ...claimStore, LastWorkingDate: e.value });
                    }
                  }
                }
              }
            >
              <RequiredRule message="Last Working Date is required" />
              <Label
                text='Date on which deceased was last actively working full time'
                location="top"
              />
            </Item>
            <Item
              dataField="event_date"
              editorType="dxDateBox"
              editorOptions={
                {
                  readOnly: false,
                  displayFormat: "dd/MM/yyyy",
                  onValueChanged: (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      //setClaimStore({ ...claimStore, event_date: e.value });
                    }
                  }
                }
              }
            >
              <RequiredRule message="Date of Death is required" />
              <Label
                text='Date of Death'
                location="top" />
            </Item>

            <Item
              colSpan={2}
              dataField="PlaceOfDeath"
              visible={vsPlaceOfDeath}
              editorType="dxTextBox"
              editorOptions={
                {
                  onValueChanged: (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      //setClaimStore({ ...claimStore, PlaceOfDeath: e.value });
                    }
                  }
                }
              }
            >
              <RequiredRule message="Place of Death is required" />
              <Label
                text='Place Of Death'
                location="top" />
            </Item>

            <Item visible={vsPlaceOfDeath} {...emptyItemConfig} />
            <Item
              colSpan={3}
              dataField="CauseOfDeath"
              visible={vsCauseOfDeath}
              editorType="dxTextArea"
              editorOptions={
                {
                  onValueChanged: (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      //setClaimStore({ ...claimStore, CauseOfDeath: e.value });
                    }
                  }
                }
              }
            >
              <RequiredRule message="Cause of Death is required" />
              <Label
                text='Cause of Death'
                location="top" />
            </Item>

            <Item
              dataField="DpWitnessName"
              visible={vsDpWitnessName}
              editorType="dxTextBox"
              editorOptions={
                {
                  readOnly: false,
                  onValueChanged: (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      //setClaimStore({ ...claimStore, BurialPermitNumber: e.value });
                    }
                  }
                }
              }
            >
              {vsDeath && <RequiredRule message="Witness Name is required" />}
              <Label text='Name of Witness'
                location="top" />
            </Item>

            <Item
              dataField="DpWitnessMobile"
              visible={vsDpWitnessMobile}
              editorType="dxTextBox"
              editorOptions={
                {
                  readOnly: false,
                  onValueChanged: (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      //setClaimStore({ ...claimStore, BurialPermitNumber: e.value });
                    }
                  }
                }
              }
            >
              {vsDeath && <RequiredRule message="Phone number of witness  is required" />}
              <Label text='Phone number of witness'
                location="top" />
            </Item>

            {/*Permits DeathCertNo, DeathEntryNo, BurialPermitNumber, IDNumber, BirthCertNumber, 
            BirthNotificationNumber*/}
            <Item
              dataField="DeathCertNo"
              visible={vsDeath}
              editorType="dxTextBox"
              editorOptions={
                {
                  readOnly: false,
                  onValueChanged: (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      //setClaimStore({ ...claimStore, DeathCertNo: e.value });
                    }
                  }
                }
              }
            >
              {vsDeath && <RequiredRule message="Death Cert No is required" />}
              <Label
                text='Death Cert No'
                location="top" />
            </Item>
            <Item
              dataField="DeathEntryNo"
              visible={vsDeath}
              editorType="dxTextBox"
              editorOptions={
                {
                  readOnly: false,
                  onValueChanged: (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      //setClaimStore({ ...claimStore, DeathEntryNo: e.value });
                    }
                  }
                }
              }
            >
              {vsDeath && <RequiredRule message="Death Entry No is required" />}
              <Label text='Death Entry Number'
                location="top" />
            </Item>
            <Item
              dataField="BurialPermitNumber"
              visible={vsDeath}
              editorType="dxTextBox"
              editorOptions={
                {
                  readOnly: false,
                  onValueChanged: (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      //setClaimStore({ ...claimStore, BurialPermitNumber: e.value });
                    }
                  }
                }
              }
            >
              {vsDeath && <RequiredRule message="Burial Permit No is required" />}
              <Label text='Burial Permit Number'
                location="top" />
            </Item>



          </GroupItem>

          {/*DETAILS OF DREAD (TERMINAL) DISEASE  */}
          <GroupItem colCount={2} caption="DETAILS OF DREAD (TERMINAL) DISEASE" visible={vsGroupDreadDisease}>
            <Item
              dataField="DreadIllness"
              editorType="dxTextArea"
              editorOptions={
                {
                  onValueChanged: (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      //setClaimStore({ ...claimStore, CauseOfDeath: e.value });
                    }
                  }
                }
              }
            >
              <RequiredRule message="Name of illness is required" />
              <Label
                text='Name of illness '
                location="top" />
            </Item>

            <Item
              dataField="DateIllnessCommencement"
              editorType="dxDateBox"
              editorOptions={
                {
                  readOnly: false,
                  displayFormat: "dd/MM/yyyy",
                  onValueChanged: (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      //setClaimStore({ ...claimStore, event_date: e.value });
                    }
                  }
                }
              }
            >
              <RequiredRule message="Date illness commenced is required" />
              <Label
                text='Date illness commenced'
                location="top" />
            </Item>

            <Item
              colSpan={2}
              dataField="DreadCondition"
              editorType="dxTextArea"
              editorOptions={
                {
                  onValueChanged: (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      //setClaimStore({ ...claimStore, CauseOfDeath: e.value });
                    }
                  }
                }
              }
            >
              <RequiredRule message="Briefly describe your condition is required" />
              <Label
                text='Briefly describe your condition'
                location="top" />
            </Item>

            <Item
              colSpan={2}
              dataField="BodyPartImpaired"
              editorType="dxTextBox"
              editorOptions={
                {
                  onValueChanged: (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      //setClaimStore({ ...claimStore, CauseOfDeath: e.value });
                    }
                  }
                }
              }
            >
              <RequiredRule message="Which part of your body has become permanently impaired as a result of the disease? is required" />
              <Label
                text='Which part of your body has become permanently impaired as a result of the disease?'
                location="top" />
            </Item>

            <Item
              colSpan={2}
              dataField="AffectedDuties"
              editorType="dxTextArea"
              editorOptions={
                {
                  onValueChanged: (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      //setClaimStore({ ...claimStore, CauseOfDeath: e.value });
                    }
                  }
                }
              }
            >
              <RequiredRule message="How has this affected your normal duties?  is required" />
              <Label
                text='How has this affected your normal duties? '
                location="top" />
            </Item>

            <Item
              colSpan={2}
              dataField="AbleToWork"
              editorType="dxLookup"
              editorOptions={
                {
                  dataSource: GlobalParams.YesNo,
                  displayExpr: "description",
                  valueExpr: "description",
                  searchEnabled: true,
                  onValueChanged: (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      //setClaimStore({ ...claimStore, Alcohol: e.value });
                    }
                  }
                }
              }
            >
              {true && <RequiredRule message="In your opinion, will you be able to continue working till retirement? required" />}
              <Label text='In your opinion, will you be able to continue working till retirement?'
                location="top" />
            </Item>



          </GroupItem>

          {/*For Accident*/}
          <GroupItem colCount={2} caption="ACCIDENT DETAILS" visible={vsGroupAccident}>
            <Item
              dataField="event_date"
              editorType="dxDateBox"
              editorOptions={
                {
                  readOnly: false,
                  displayFormat: "dd/MM/yyyy",
                  onValueChanged: (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      //setClaimStore({ ...claimStore, event_date: e.value });
                    }
                  }
                }
              }
            >
              <RequiredRule message="Date of Accident is required" />
              <Label
                text='Date of Accident'
                location="top" />
            </Item>

            <Item
              colSpan={2}
              dataField="PlaceOfDeath"
              editorType="dxTextBox"
              editorOptions={
                {
                  onValueChanged: (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      //setClaimStore({ ...claimStore, PlaceOfDeath: e.value });
                    }
                  }
                }
              }
            >
              <RequiredRule message="Place of Accident is required" />
              <Label
                text='Place Of Accident'
                location="top" />
            </Item>

            <Item
              colSpan={2}
              dataField="CauseOfDeath"
              editorType="dxTextArea"
              editorOptions={
                {
                  onValueChanged: (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      //setClaimStore({ ...claimStore, CauseOfDeath: e.value });
                    }
                  }
                }
              }
            >
              <RequiredRule message="Cause of Accident is required" />
              <Label
                text='Briefly describe how the accident happened and what you were doing before the accident'
                location="top" />
            </Item>


            <Item
              colSpan={2}
              dataField="Alcohol"
              editorType="dxLookup"
              editorOptions={
                {
                  dataSource: GlobalParams.YesNo,
                  displayExpr: "description",
                  valueExpr: "description",
                  searchEnabled: true,
                  onValueChanged: (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      //setClaimStore({ ...claimStore, Alcohol: e.value });
                    }
                  }
                }
              }
            >
              {true && <RequiredRule message="required" />}
              <Label text='Did you take in alcohol or drugs before the accident?  ' />
            </Item>


            <Item
              colSpan={2}
              dataField="NamePhoneOfWitness"
              editorType="dxTextArea"
              editorOptions={
                {
                  onValueChanged: (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      //setClaimStore({ ...claimStore, CauseOfDeath: e.value });
                    }
                  }
                }
              }
            >
              <RequiredRule message="Name and phone no. of witness(es)  is required" />
              <Label
                text='Name and phone no. of witness(es)'
                location="top" />
            </Item>


            <Item
              colSpan={2}
              dataField="ExactInjury"
              editorType="dxTextArea"
              editorOptions={
                {
                  onValueChanged: (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      //setClaimStore({ ...claimStore, CauseOfDeath: e.value });
                    }
                  }
                }
              }
            >
              <RequiredRule message="Exact injuries is required" />
              <Label
                text='Briefly describe the exact injuries you sustained (please note: this should be your own description and not the doctor’s) '
                location="top" />
            </Item>

            <Item
              colSpan={2}
              dataField="YouHospitalized"
              editorType="dxLookup"
              editorOptions={
                {
                  dataSource: GlobalParams.YesNo,
                  displayExpr: "description",
                  valueExpr: "description",
                  searchEnabled: false,
                  onValueChanged: async (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      //setClaimStore({ ...claimStore, AnyOutstandingLoan: e.value });
                      if (e.value === "YES") {
                        setVsHospital(true);
                        setVsDoctorName(true);
                      } else {
                        setVsHospital(false);
                        setVsDoctorName(false);
                      }
                    }
                  }
                }
              }
            >
              <RequiredRule message="Were you hospitalized? is required" />
              <Label text='Were you hospitalized? ' location="top" />
            </Item>

            <Item
              dataField="Hospital"
              visible={vsHospital}
              editorType="dxTextBox"
              editorOptions={
                {
                  onValueChanged: (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      //setClaimStore({ ...claimStore, CauseOfDeath: e.value });
                    }
                  }
                }
              }
            >
              <RequiredRule message="Which Hospital is required" />
              <Label
                text='Which hospital? '
                location="top" />
            </Item>

            <Item
              colSpan={2}
              dataField="DoctorName"
              visible={vsDoctorName}
              editorType="dxTextBox"
              editorOptions={
                {
                  onValueChanged: (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      //setClaimStore({ ...claimStore, CauseOfDeath: e.value });
                    }
                  }
                }
              }
            >
              <RequiredRule message="Name of the doctor, who attended to you is required" />
              <Label
                text='Name of the doctor, who attended to you'
                location="top" />
            </Item>


            <Item
              colSpan={2}
              dataField="AreYouDisabled"
              editorType="dxLookup"
              editorOptions={
                {
                  dataSource: GlobalParams.YesNo,
                  displayExpr: "description",
                  valueExpr: "description",
                  searchEnabled: false,
                  onValueChanged: async (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      //setClaimStore({ ...claimStore, AnyOutstandingLoan: e.value });
                      if (e.value === "YES") {
                        setVsDisabilityDateFrom(true);
                        setVsDisabilityDateTo(true);
                      } else {
                        setVsDisabilityDateFrom(false);
                        setVsDisabilityDateTo(false);
                      }
                    }
                  }
                }
              }
            >
              <RequiredRule message="Are You Disabled is required" />
              <Label text='Are You Disabled? ' location="top" />
            </Item>

            {/*Date from, Date To  */}

            <Item
              dataField="DisabilityDateFrom"
              visible={vsDisabilityDateFrom}
              editorType="dxDateBox"
              editorOptions={
                {
                  readOnly: false,
                  displayFormat: "dd/MM/yyyy",
                  onValueChanged: (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      //setClaimStore({ ...claimStore, event_date: e.value });
                    }
                  }
                }
              }
            >
              <RequiredRule message="Disability Date From is required" />
              <Label
                text='Disability Date From'
                location="top" />
            </Item>

            <Item
              dataField="DisabilityDateTo"
              visible={vsDisabilityDateTo}
              editorType="dxDateBox"
              editorOptions={
                {
                  readOnly: false,
                  displayFormat: "dd/MM/yyyy",
                  onValueChanged: (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      //setClaimStore({ ...claimStore, event_date: e.value });
                    }
                  }
                }
              }
            >
              <RequiredRule message="Disability Date To is required" />
              <Label
                text='Disability Date To'
                location="top" />
            </Item>


            <Item
              colSpan={2}
              dataField="DisPrevWork"
              editorType="dxLookup"
              editorOptions={
                {
                  dataSource: GlobalParams.YesNo,
                  displayExpr: "description",
                  valueExpr: "description",
                  searchEnabled: false,
                  onValueChanged: async (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      //setClaimStore({ ...claimStore, AnyOutstandingLoan: e.value });
                    }
                  }
                }
              }
            >
              <RequiredRule message="Will the disability prevent you from working again is required" />
              <Label text='Will the disability prevent you from working again' location="top" />
            </Item>

          </GroupItem>



          {/*For Accident claim  */}
          <GroupItem colCount={2} caption="LOSS OF SEXUAL FUNCTIONALITY OF SEXUAL ORGAN"
            visible={vsGroupAccidentSex}>
            <Item
              colSpan={2}
              dataField="HasAffectedSex"
              editorType="dxLookup"
              editorOptions={
                {
                  dataSource: GlobalParams.YesNo,
                  displayExpr: "description",
                  valueExpr: "description",
                  searchEnabled: false,
                  onValueChanged: async (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      //setClaimStore({ ...claimStore, AnyOutstandingLoan: e.value });
                    }
                  }
                }
              }
            >
              <RequiredRule message="Has the accident affected the sexual functionality of your sexual organ? is required" />
              <Label text='Has the accident affected the sexual functionality of your sexual organ?' location="top" />
            </Item>

            <Item
              colSpan={2}
              dataField="SexCondition"
              editorType="dxTextArea"
            >
              <RequiredRule message="Please describe your condition briefly is required" />
              <Label
                text='Please describe your condition briefly'
                location="top" />
            </Item>

            <Item
              colSpan={2}
              dataField="ConsultSexDoctor"
              editorType="dxLookup"
              editorOptions={
                {
                  dataSource: GlobalParams.YesNo,
                  displayExpr: "description",
                  valueExpr: "description",
                  searchEnabled: false,
                  onValueChanged: async (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      //setClaimStore({ ...claimStore, AnyOutstandingLoan: e.value });
                      if (e.value === "YES") {
                        setVsSexDoctorName(true);
                        setVsSexDoctorMobile(true);
                      } else {
                        setVsSexDoctorName(false);
                        setVsSexDoctorMobile(false);
                      }
                    }
                  }
                }
              }
            >
              <RequiredRule message="Have you consulted a medical doctor? is required" />
              <Label text='Have you consulted a medical doctor?' location="top" />
            </Item>

            <Item
              dataField="SexDoctorName"
              visible={vsSexDoctorName}
              editorType="dxTextBox"
            >
              <RequiredRule message="Name of the doctor, who attended to you is required" />
              <Label
                text='Name of the doctor, who attended to you'
                location="top" />
            </Item>

            <Item
              dataField="SexDoctorMobile"
              visible={vsSexDoctorMobile}
              editorType="dxTextBox"
            >
              <RequiredRule message="Telephone Number of the doctor, who attended to you is required" />
              <Label
                text='Telephone Number of the doctor, who attended to you'
                location="top" />
            </Item>


          </GroupItem>

          {/*For Loan */}

          <GroupItem colCount={2} caption="OTHER DETAILS" visible={vsGroupOtherDetails}>
            <Item
              colSpan={2}
              dataField="ContributionYears"
              visible={vsContributionYears}
              editorType="dxNumberBox"
              editorOptions={
                {
                  onValueChanged: async (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      //setClaimStore({ ...claimStore, ContributionYears: e.value });
                    }
                  }
                }
              }
            >
              <RequiredRule message="How many years have you contributed to POPFUND is required" />
              <Label text='How many years have you contributed to POPFUND' location="top" />
            </Item>

            <Item
              colSpan={2}
              dataField="AnyOutstandingLoan"
              visible={vsAnyOutstandingLoan}
              editorType="dxLookup"
              editorOptions={
                {
                  dataSource: GlobalParams.YesNo,
                  displayExpr: "description",
                  valueExpr: "description",
                  searchEnabled: false,
                  onValueChanged: async (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      //setClaimStore({ ...claimStore, AnyOutstandingLoan: e.value });
                      if (e.value === "YES") {
                        notify("Kindly settle your outstanding loan before applying for a new one..", 'error', 10000);
                        onClosePopup();
                      }
                    }
                  }
                }
              }
            >
              <RequiredRule message=" Do you have any outstanding loan with POPFUND is required" />
              <Label text=' Do you have any outstanding loan with POPFUND' location="top" />
            </Item>

            <Item
              colSpan={2}
              dataField="AnyOtherInstitutionLoan"
              visible={vsAnyOtherInstitutionLoan}
              editorType="dxLookup"
              editorOptions={
                {
                  dataSource: GlobalParams.YesNo,
                  displayExpr: "description",
                  valueExpr: "description",
                  searchEnabled: false,
                  onValueChanged: async (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      //setClaimStore({ ...claimStore, AnyOtherInstitutionLoan: e.value });
                    }
                  }
                }
              }
            >
              <RequiredRule message="Have you taken loan facility from another institution or organization is required" />
              <Label text='Have you taken loan facility from another institution or organization' location="top" />
            </Item>

            <Item
              colSpan={2}
              dataField="LoanAmount"
              visible={vsLoanAmount}
              editorType="dxNumberBox"
              editorOptions={
                {
                  onValueChanged: async (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      //setClaimStore({ ...claimStore, LoanAmount: e.value });
                    }
                  }
                }
              }
            >
              <RequiredRule message="Loan amount required : Gh¢  is required" />
              <Label text='Loan amount required : Gh¢ ' location="top" />
            </Item>

            <Item
              colSpan={2}
              dataField="LoanAmountInWords"
              visible={vsLoanAmountInWords}
              editorType="dxTextArea"
              editorOptions={
                {
                  onValueChanged: async (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      //setClaimStore({ ...claimStore, LoanAmountInWords: e.value });
                    }
                  }
                }
              }
            >
              <RequiredRule message="Loan Amount in words  is required" />
              <Label text='Loan Amount in words ' location="top" />
            </Item>

            <Item
              colSpan={2}
              dataField="LoanPurpose"
              visible={vsLoanPurpose}
              editorType="dxTextArea"
              editorOptions={
                {
                  onValueChanged: async (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      //setClaimStore({ ...claimStore, LoanPurpose: e.value });
                    }
                  }
                }
              }
            >
              <RequiredRule message="Loan Purpose  is required" />
              <Label text='Loan Purpose' location="top" />
            </Item>

            <Item
              colSpan={2}
              dataField="RepaymentPeriod"
              visible={vsRepaymentPeriod}
              editorType="dxLookup"
              editorOptions={
                {
                  dataSource: [
                    { 'id': 1, 'description': '12' },
                    { 'id': 2, 'description': '24' },
                    { 'id': 3, 'description': '36' }
                  ],
                  displayExpr: "description",
                  valueExpr: "description",
                  searchEnabled: false,
                  onValueChanged: async (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      //setClaimStore({ ...claimStore, AnyOtherInstitutionLoan: e.value });
                    }
                  }
                }
              }
            >
              <RequiredRule message="Preferred repayment period is required" />
              <Label text='Preferred repayment period in Months' location="top" />
            </Item>

            {/* <Item
              dataField="RepaymentPeriod"
              visible={vsRepaymentPeriod}
              editorType="dxNumberBox"
              editorOptions={
                {
                  onValueChanged: async (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {

                    }
                  }
                }
              }
            >
              <RequiredRule message="Preferred repayment period is required" />
              <Label text='Preferred repayment period' location="top" />
            </Item> */}

            <Item
              dataField="CurrentNetPay"
              visible={vsCurrentNetPay}
              editorType="dxNumberBox"
              editorOptions={
                {
                  onValueChanged: async (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      //setClaimStore({ ...claimStore, CurrentNetPay: e.value });
                    }
                  }
                }
              }
            >
              <RequiredRule message="Current Affordability : Gh¢  is required" />
              <Label text='Current Affordability : Gh¢' location="top" />
            </Item>

            <Item
              dataField="YearsToRetirement"
              visible={vsYearsToRetirement}
              editorType="dxNumberBox"
              editorOptions={ 
                {
                  onValueChanged: async (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      //setClaimStore({ ...claimStore, YearsToRetirement: e.value });
                    }
                  }
                }
              }
            >
              <RequiredRule message="Remaining years to retirement is required" />
              <Label text='Remaining years to retirement' location="top" />
            </Item>


          </GroupItem>



          <GroupItem colCount={3} caption="PAYMENT DETAILS" visible={vsGroupPaymentDetails}>
            {/*paymentOptions,ClaimDefaultPay_method, Bank, BankBranch, BankAccount, MobileNumber*/}
            {/*Add PaymentOptions */}
            <Item
              dataField="paymentOptions"
              editorType="dxLookup"
              visible={vsClaimPaymentOptions}
              editorOptions={
                {
                  dataSource: GlobalParams.PaymentOptions,
                  displayExpr: "name",
                  valueExpr: "id",
                  searchEnabled: false,
                  onValueChanged: (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      //if beneficiary show the beneficiary button 
                      //else hide all the bank details
                      /*if (e.value === '2') {
                        //Display benefeciary and hide payment details
                        setVsBeneficiariesGrid(true);
                        setVsPayMethod(false);
                        setVsBank(false);
                        setVsMpesa(false);
                      } else {
                        //Display Payment Details
                        setVsBeneficiariesGrid(false);
                        setVsPayMethod(true);
                      }*/
                    }
                  }
                }
              }
            >
              <RequiredRule message="Payment Options is required" />
              <Label text='Payment Options' location="top" />
            </Item>

            <Item visible={vsClaimPayMethod} {...emptyItemConfig} />

            <Item
              colSpan={3}
              dataField="ClaimDefaultPay_method"
              visible={vsClaimPayMethod}
              editorType="dxLookup"
              editorOptions={
                {
                  dataSource: GlobalParams.ClaimPaymentMethods,
                  displayExpr: "name",
                  valueExpr: "id",
                  searchEnabled: false,
                  onValueChanged: (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {

                      PaymentMethodChanged(e.value);
                      //setClaimStore({ ...claimStore, PayMethod: e.value });


                    }
                  }
                }
              }
            >
              <RequiredRule message="Pay Method is Required" />
              <Label text='Pay Method' location="top" />
            </Item>

            <Item
              dataField="ClaimDefaultEFTBank_code"
              editorType="dxLookup"
              visible={vsBank}
              editorOptions={
                {
                  dataSource: GlobalParams.Banks,
                  displayExpr: "description",
                  valueExpr: "bank_code",
                  searchEnabled: true,
                  onValueChanged: async (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      console.log(e.value);
                      console.log(claimStore.Bank);
                      //if (e.value !== claimStore.Bank) {
                      console.log(e.value);
                      //setClaimStore({ ...claimStore, Bank: e.value });
                      //TODO - fetch the bank branches..
                      setIsLoading(true);
                      let tmp_bankBranch = await fetchBankBranch(e.value);
                      setBankBranches(tmp_bankBranch);
                      //}
                    }
                  }
                }
              }
            >
              {true && <RequiredRule message="Bank is required" />}
              <Label text='Bank' location="top" />
            </Item>

            <Item
              dataField="ClaimDefaultEFTBankBranchCode"
              editorType="dxLookup"
              visible={vsBank}
              editorOptions={
                {
                  dataSource: bankBranches,
                  displayExpr: "bankBranchName",
                  valueExpr: "id",
                  searchEnabled: true,
                  onValueChanged: (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      //setClaimStore({ ...claimStore, BankBranch: e.value });
                    }
                  }
                }
              }
            >
              {/* {true && <RequiredRule message="Bank is required" />} */}
              <Label text='Bank Branch' location="top" />
            </Item>

            <Item
              dataField="ClaimDefaultEFTBank_account"
              editorType="dxTextBox"
              visible={vsBank}
              editorOptions={
                {
                  onValueChanged: (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      //setClaimStore({ ...claimStore, BankAccount: e.value });
                    }
                  }
                }
              }
            >
              {true && <RequiredRule message="Bank is required" />}
              <Label text='Bank Account' location="top" />
            </Item>

            <Item
              dataField="ClaimDefaultEftBankaccountName"
              editorType="dxTextBox"
              visible={vsBank}
              editorOptions={
                {
                  onValueChanged: (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      //setClaimStore({ ...claimStore, BankAccountName: e.value });
                    }
                  },
                  //value: MemberName
                }
              }
            >
              {vsBank && <RequiredRule message="Bank Account Name is required" />}
              <Label text='Bank Account Name' location="top" />
            </Item>

            {/*Add Telco Company */}
            <Item
              dataField="ClaimDefaultTelcoCompany"
              editorType="dxLookup"
              visible={vsMpesa}
              editorOptions={
                {
                  dataSource: GlobalParams.MoMoTelcoStore,
                  displayExpr: "description",
                  valueExpr: "id",
                  searchEnabled: true,
                  onValueChanged: (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      //setClaimStore({ ...claimStore, MoMoTelco: e.value });
                    }
                  }
                }
              }
            >
              {true && <RequiredRule message="MOMO Telco is required" />}
              <Label text='MOMO Telco' location="top" />
            </Item>


            <Item
              dataField="ClaimDefaultMobileWallet"
              editorType="dxTextBox"
              visible={vsMpesa}
              editorOptions={
                {
                  onValueChanged: (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      //setClaimStore({ ...claimStore, MoMoNumber: e.value });
                    }
                  },
                  mask: '233 000-000-000',
                  maskRules: { X: /[02-9]/ }
                }
              }
            >
              {true && <RequiredRule message="MOMO Number is required" />}
              <Label text='MOMO Number' location="top" />
            </Item>
          </GroupItem>

          <GroupItem>
            <Item colSpan={3}>
              {documentsData.map((document, index) => {
                let tmpIsMandatry = document.IsMandatory === "1"; // Set tmpIsMandatry based on IsMandatory value

                return (
                  <div key={document.req_code}>
                    <p>{document.description}</p>
                    <CheckBox
                      value={tmpIsMandatry}
                      disabled={true} // Disable the checkbox if IsMandatory is true
                      text="It's Mandatory"
                    />
                    <FileUploader
                      multiple={true}
                      uploadMode="useForm"
                      // accept="image/*"  // Restrict to image files
                      onValueChanged={(e) => {
                        let files = e.value;
                        let doc_code = document.req_code;
                        console.log(doc_code);
                        filesData.push({ [doc_code]: files[0] });
                      }}
                      style={{ borderBottom: '1px solid #000' }}
                    />
                  </div>
                );
              })}
            </Item>
          </GroupItem>

          {/*Display Documents in a Grid*/}
          <GroupItem caption="ATTACHED DOCUMENTS" visible={vsGroupAttachmentsData}>
            <Item colSpan={3}>
              <DataGrid
                width={'96%'}
                dataSource={attachmentData} wordWrapEnabled={true} columnHidingEnabled={false}
                searchPanel={searchPanelOptions}
                allowColumnReordering={true}
                onRowClick={(e) => {
                  //window.open('http://192.168.1.24:90/SmartLifeDocuments/ClaimsDocuments/' + e.data.FileName, '_blank', 'hidden=no');
                  window.open('https://smartlife.glicolife.com/SmartLifeDocuments/ClaimsDocuments/' + e.data.FileName, '_blank', 'hidden=no');
                }}
              >
                <Column dataField="DocumentCode" visible={false} ></Column>
                <Column dataField="Description"></Column>
                <Column dataField="FileName"></Column>
                <Column dataField="FullFilePath" visible={false}></Column>
              </DataGrid>
            </Item>
          </GroupItem>

          {/*For Approval Purposes ApprovalStore*/}
          <GroupItem colCount={1} caption="APPROVAL DETAILS" visible={vsGroupApproval}>
            <Item
              dataField="OICRecomendation"
              editorType="dxLookup"
              visible={vsOICRecomendation}
              editorOptions={
                {
                  dataSource: GlobalParams.ApprovalStore,
                  displayExpr: "description",
                  valueExpr: "description",
                  searchEnabled: false,
                  onValueChanged: (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      //setClaimStore({ ...claimStore, OICRecomendation: e.value });
                    }
                  }
                }
              }
            >
              <RequiredRule message="Recommendation is required" />
              <Label text='Recommendation' location="top" />
            </Item>

            <Item
              dataField="OICComments"
              editorType="dxTextArea"
              visible={vsOICComments}
              editorOptions={
                {
                  onValueChanged: (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      //setClaimStore({ ...claimStore, OICComments: e.value });
                    }
                  }
                }
              }
            >
              <RequiredRule message="Comments is required" />
              <Label text='Comments' location="top" />
            </Item>

            <Item
              dataField="SecretariatRecomendation"
              editorType="dxLookup"
              visible={vsSecretariatRecomendation}
              editorOptions={
                {
                  dataSource: GlobalParams.ApprovalStore,
                  displayExpr: "description",
                  valueExpr: "description",
                  searchEnabled: false,
                  onValueChanged: (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      //setClaimStore({ ...claimStore, SecretariatRecomendation: e.value });
                    }
                  }
                }
              }
            >
              <RequiredRule message="Recommendation is required" />
              <Label text='Recommendation' location="top" />
            </Item>

            <Item
              dataField="SecretariatComments"
              editorType="dxTextArea"
              visible={vsSecretariatComments}
              editorOptions={
                {
                  onValueChanged: (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      //setClaimStore({ ...claimStore, SecretariatComments: e.value });
                    }
                  }
                }
              }
            >
              <RequiredRule message="Comments is required" />
              <Label text='Comments' location="top" />
            </Item>


            {/*Broker Approval*/}
            <Item
              dataField="BrokerRecomendation"
              editorType="dxLookup"
              visible={vsBrokerRecomendation}
              editorOptions={
                {
                  dataSource: GlobalParams.ApprovalStore,
                  displayExpr: "description",
                  valueExpr: "description",
                  searchEnabled: false,
                  onValueChanged: (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      //setClaimStore({ ...claimStore, SecretariatRecomendation: e.value });
                    }
                  }
                }
              }
            >
              <RequiredRule message="Recommendation is required" />
              <Label text='Recommendation' location="top" />
            </Item>

            <Item
              dataField="BrokerComments"
              editorType="dxTextArea"
              visible={vsBrokerComments}
              editorOptions={
                {
                  onValueChanged: (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      //setClaimStore({ ...claimStore, SecretariatComments: e.value });
                    }
                  }
                }
              }
            >
              <RequiredRule message="Comments is required" />
              <Label text='Comments' location="top" />
            </Item>

          </GroupItem>
          <GroupItem>
            <ButtonItem
              colSpan={3}
            >
              <ButtonOptions
                type='default'
                text="SUBMIT"
                icon='save'
                useSubmitBehavior={true}
              />
            </ButtonItem>
          </GroupItem>

        </Form>
      </form>

      <br></br>

    </div>
  );
}

export default NewClaim;